/**
 * Intarsia Add-to-Cart Fix
 * Prevents double submissions by overriding the form handler
 * Place this AFTER ajax-cart.js in theme.liquid
 */

(function($) {
  'use strict';
  
  // Wait for DOM and ajax-cart to be ready
  $(document).ready(function() {
    
    // Small delay to ensure ajax-cart.js has initialized
    setTimeout(function() {
      
      var isSubmitting = false;
      var formSelector = 'form[action^="/cart/add"]';
      
      // Remove ALL existing submit handlers from cart forms
      $(formSelector).off('submit');
      
      // Add our single, controlled handler
      $(document).on('submit', formSelector, function(evt) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
        
        // Block if already submitting
        if (isSubmitting) {
          console.log('Intarsia: Blocked duplicate add-to-cart');
          return false;
        }
        
        isSubmitting = true;
        
        var $form = $(this);
        var $btn = $form.find('.enj-add-to-cart-btn, [type="submit"], [name="add"]').first();
        
        // Disable button
        $btn.prop('disabled', true);
        
        // Show loading state
        $btn.removeClass('is-added').addClass('is-adding');
        var $icon = $btn.find('i');
        var originalIcon = $icon.length ? $icon[0].outerHTML : '';
        $btn.find('i').replaceWith('<i class="enj-loader-add-to-cart"><svg viewBox="0 0 24 30" height="20px" width="21px"><rect fill="#fff" height="8" width="3" y="10" x="0"><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="0.2;1;.2" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="10;20;10" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="10;5;10" attributeName="y"/></rect><rect fill="#fff" height="8" width="3" y="10" x="8"><animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="0.2;1;.2" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="10;20;10" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="10;5;10" attributeName="y"/></rect><rect fill="#fff" height="8" width="3" y="10" x="16"><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="0.2;1;.2" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="10;20;10" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="10;5;10" attributeName="y"/></rect></svg></i>');
        
        // Remove previous errors
        $('.qty-error').remove();
        
        // Make the AJAX call
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: $form.serialize(),
          dataType: 'json',
          success: function(product) {
            console.log('Intarsia: Item added successfully', product.title);
            
            // Update button state
            $btn.removeClass('is-adding').addClass('is-added');
            $btn.find('.enj-loader-add-to-cart').html('<svg viewBox="0 0 24 24" width="20" height="20"><path fill="#fff" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>');
            
            // Update popup if it exists
            if ($('.product-popup').length) {
              $('.product-popup').find('.product-name').html(product.title);
              $('.product-popup').find('.product-price').html(Shopify.formatMoney(product.price, window.money_format));
              $('.product-popup').find('.product-qty').html(product.quantity);
              $('.product-popup').find('.product-total').html(Shopify.formatMoney(product.line_price, window.money_format));
              $('.product-popup').find('.product-image img').attr('src', product.image);
              
              // Show popup
              if (typeof showPopup === 'function') {
                showPopup('.product-popup');
              } else {
                $('.product-popup').addClass('active');
              }
            }
            
            // Update cart count and totals, then open minicart
            $.getJSON('/cart.js', function(cart) {
              // Update cart count
              $('.enj-cartcount, .cart-count, .cart-counter').html(cart.item_count);
              $('.mini-cart-counter span').html(cart.item_count);
              $('.product-popup .product-item-count').html(cart.item_count);
              $('.product-popup .product-total-cart').html(Shopify.formatMoney(cart.total_price, window.money_format));
              
              // Update minicart content if ajaxCart exists
              if (typeof ajaxCart !== 'undefined' && ajaxCart.load) {
                ajaxCart.load();
              }
              
              // Trigger events for other scripts
              $('body').trigger('ajaxCart.afterCartLoad', cart);
              
              // Show cart indicator
              $('.js-number-cart').addClass('active');
              
              // Open the minicart drawer
              $('.js-minicart').addClass('active');
              $('.bg-minicart').addClass('active');
            });
            
            // Re-enable after delay
            setTimeout(function() {
              isSubmitting = false;
              $btn.prop('disabled', false);
            }, 1500);
          },
          error: function(xhr) {
            console.error('Intarsia: Add to cart error', xhr);
            
            // Re-enable immediately on error
            isSubmitting = false;
            $btn.prop('disabled', false);
            $btn.removeClass('is-adding is-added');
            
            // Restore original icon
            if (originalIcon) {
              $btn.find('.enj-loader-add-to-cart').replaceWith(originalIcon);
            }
            
            // Show error
            try {
              var data = JSON.parse(xhr.responseText);
              if (data.description) {
                $form.after('<div class="errors qty-error">' + data.description + '</div>');
              }
            } catch (e) {
              $form.after('<div class="errors qty-error">Unable to add item to cart. Please try again.</div>');
            }
          }
        });
        
        return false;
      });
      
      console.log('Intarsia: Add-to-cart fix loaded');
      
    }, 500); // Wait 500ms for ajax-cart.js to initialize
    
  });
  
})(jQuery);
